import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
const play = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 11 14", fill: "currentColor", width: size || "11", height: size || "14" }, props),
        React.createElement("g", { id: "final", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { id: "Pause", transform: "translate(-490 -763)", fill: "currentColor" },
                React.createElement("g", { id: "Group-2", transform: "translate(470 284)" },
                    React.createElement("g", { id: "Group", transform: "translate(20 479)" },
                        React.createElement("path", { id: "play", d: "M0.0788076641 0L0 14 10.5 6.81856071z" })))))));
};
play.displayName = 'play';
play.propTypes = {
    size: PropTypes.string
};
export default play;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=play.js.map